var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_56",
    "data-name": 56,
    clipPath: "url(#clip-_56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20087",
    "data-name": "Group 20087",
    transform: "translate(-33 -24.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1038",
    transform: "translate(65 60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g997",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M71.272,34.178A24.793,24.793,0,1,0,66.81,68.95a24.793,24.793,0,0,0,4.463-34.772Z",
    transform: "translate(-26.856 -24.538)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M52.644,34.877,42.189,45.414l-2.954-3.037c10.289-10.289,11.322-9.359,13.409-7.5Z",
    transform: "translate(-19.487 -19.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M42.329,45.842h0a.372.372,0,0,1-.248-.1l-2.975-2.975a.372.372,0,0,1,0-.517c10.144-10.144,11.529-9.669,13.925-7.5a.331.331,0,0,1,.124.269.289.289,0,0,1-.1.269L42.6,45.739A.393.393,0,0,1,42.329,45.842Zm-2.438-3.326,2.438,2.438,9.917-9.917a2.231,2.231,0,0,0-2.934-.5c-1.8.806-4.69,3.264-9.421,7.975Z",
    transform: "translate(-19.626 -19.219)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M44.029,47.813,41.178,44.9,51.632,34.57C54.442,37.318,50.268,41.9,44.029,47.813Z",
    transform: "translate(-18.331 -18.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M44.157,48.371h0a.434.434,0,0,1-.248-.1L41,45.417a.434.434,0,0,1,0-.331.393.393,0,0,1,0-.269L51.45,34.363a.393.393,0,0,1,.537,0,3.2,3.2,0,0,1,1.033,2.459c0,2.789-3.182,6.3-8.595,11.425A.434.434,0,0,1,44.157,48.371Zm-2.314-3.285,2.335,2.335c4.132-3.9,8.078-7.934,8.1-10.661a2.355,2.355,0,0,0-.537-1.591Z",
    transform: "translate(-18.459 -18.752)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M40.329,39.2l2.066,2.066a.124.124,0,0,1,0,.186l-4.359.93a.413.413,0,0,1-.372-.7L40.2,39.155a.2.2,0,0,1,.124.041Z",
    transform: "translate(-20.498 -15.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M38.073,42.923a.806.806,0,0,1-.682-.393.785.785,0,0,1,.145-.93l2.521-2.541a.5.5,0,0,1,.661,0l2.066,2.066a.455.455,0,0,1,.124.455.475.475,0,0,1-.351.331l-4.359.93Zm2.314-3.14-2.335,2.335h0l3.864-.826ZM40.573,39.6Z",
    transform: "translate(-20.639 -15.969)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M53.659,31.22a4.008,4.008,0,1,0-.723,6.322l-2.81-2.81Z",
    transform: "translate(-14.944 -21.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M50.989,38.616a4.373,4.373,0,1,1,3.14-7.459.351.351,0,0,1,0,.537l-3.347,3.161,2.541,2.5a.351.351,0,0,1,.1.31.372.372,0,0,1-.165.269,4.483,4.483,0,0,1-2.273.682Zm0-8.016a3.631,3.631,0,1,0,1.446,6.963L50,35.124a.331.331,0,0,1,0-.517l3.223-3.244a3.7,3.7,0,0,0-2.231-.764Z",
    transform: "translate(-15.064 -21.352)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M52.481,30.84h0l-3.533,3.512,2.81,2.81a4.277,4.277,0,0,0,.785-.578,4.132,4.132,0,0,0-.062-5.744Z",
    transform: "translate(-13.705 -20.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M51.858,37.626a.31.31,0,0,1-.248-.1l-2.81-2.81a.331.331,0,0,1,0-.517l3.512-3.45a.372.372,0,0,1,.62,0h0a4.339,4.339,0,0,1,0,6.2,3.761,3.761,0,0,1-.826.661.331.331,0,0,1-.248.021Zm-2.273-3.182,2.335,2.335a3.966,3.966,0,0,0,.455-.372,3.657,3.657,0,0,0,1.074-2.583,3.554,3.554,0,0,0-.888-2.355Z",
    transform: "translate(-13.867 -20.941)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M52.176,34.865h0a1.508,1.508,0,0,0-2.066,0L40.75,44.2l1.55,1.57L52.2,37.1a1.529,1.529,0,0,0-.021-2.231Z",
    transform: "translate(-18.585 -18.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M42.387,46.285a.372.372,0,0,1-.248-.1l-1.57-1.57a.372.372,0,0,1,0-.517l9.359-9.318a1.9,1.9,0,0,1,2.686,0h0a1.9,1.9,0,0,1,.558,1.4,1.942,1.942,0,0,1-.64,1.364l-9.9,8.678A.351.351,0,0,1,42.387,46.285Zm-1.1-1.942L42.325,45.4l9.711-8.45a1.136,1.136,0,0,0,.393-.826,1.1,1.1,0,0,0-.351-.847,1.157,1.157,0,0,0-1.632,0Z",
    transform: "translate(-18.755 -18.773)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M37.422,50.628a.207.207,0,0,0,0,.248l.413,1.8a.517.517,0,0,1-.847.475l-2.831-2.727,8.822-8.884h3.058L48.1,43.6a46.879,46.879,0,0,1-10.682,7.025Z",
    transform: "translate(-22.509 -14.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M37.375,53.812a.888.888,0,0,1-.62-.269l-2.707-2.707a.331.331,0,0,1,0-.517l8.884-8.9a.351.351,0,0,1,.186-.1H46.2a.372.372,0,0,1,.248,0l2.066,2.066a.4.4,0,0,1-.021.558l-.165.145a50.619,50.619,0,0,1-10.6,6.8l.393,1.674a.888.888,0,0,1-.847,1.1Zm-2.521-3.244,2.438,2.459a.11.11,0,1,0,.165-.145l-.413-1.8a.578.578,0,0,1,.31-.661h0a50.8,50.8,0,0,0,10.33-6.653l-1.694-1.694H43.222ZM37.83,50.94Z",
    transform: "translate(-22.648 -14.565)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M32.9,49.212l2.066-2.066,3.182,3.182-5.062-.351a.413.413,0,0,1-.186-.764Z",
    transform: "translate(-23.377 -11.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M38.3,50.769h0l-5.041-.351a.785.785,0,0,1-.5-1.322h0l2.066-2.066a.372.372,0,0,1,.517,0l3.161,3.161a.351.351,0,0,1,0,.413A.393.393,0,0,1,38.3,50.769Zm-5.041-1.157,4.132.269-2.273-2.128Z",
    transform: "translate(-23.469 -11.212)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon52",
    d: "M16.607,18.14l-4.173.64,2.417-2.4Z",
    transform: "translate(7.211 9.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M39.319,43.514a.414.414,0,0,1-.331-.62l2.4-2.417a.393.393,0,0,1,.537,0l1.756,1.756a.48.48,0,0,1-.289.64l-4.132.64Zm2.417-2.252L40.393,42.6l2.314-.351Z",
    transform: "translate(-19.674 -15.114)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M43.043,42.348l-2.913.372a.372.372,0,0,1-.351-.62l1.508-1.508Z",
    transform: "translate(-19.225 -14.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M40.19,43.253a.764.764,0,0,1-.661-.393.744.744,0,0,1,.124-.888l1.508-1.508a.393.393,0,0,1,.537,0l1.756,1.756a.372.372,0,0,1-.227.64l-2.893.372Zm0-.764h0l2.19-.269-.971-.971-1.24,1.24Z",
    transform: "translate(-19.368 -15.121)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M51.439,32.385a.31.31,0,0,0-.393-.124.289.289,0,0,0-.124.393.888.888,0,0,1-.1.93.269.269,0,0,0,0,.393.227.227,0,0,0,.165,0,.269.269,0,0,0,.269-.083,1.426,1.426,0,0,0,.186-1.508Z",
    transform: "translate(-12.642 -19.956)",
    fill: "#ff6c37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(59.858 16.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30-9",
    d: "M73.579,59.908c-.888,1.85-1.628,3.552-2.442,5.255-.222.444-.37,1.036-.814,1.036-.592,0-.666-.592-.888-1.11-.666-1.48-1.332-2.96-2-4.367-.148-.222-.148-.666-.444-.592-.37.074-.3.518-.3.814V69.9a8.042,8.042,0,0,1-.074,1.332.807.807,0,0,1-.814.74.787.787,0,0,1-.666-.74V57.318c0-.592-.148-1.406.518-1.628.74-.222,1.184.37,1.48,1.036.814,1.7,1.48,3.4,2.294,5.033.222.444.3,1.258.888,1.332.666,0,.74-.888.962-1.332.814-1.628,1.48-3.256,2.294-4.885.3-.666.666-1.332,1.48-1.184.814.222.592,1.036.592,1.7V70.27c0,.666.222,1.7-.74,1.7-1.036,0-.814-1.036-.814-1.776V61.685c-.074-.592.074-1.184-.518-1.776Z",
    transform: "translate(4.722 -55.316)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32-1",
    d: "M90.965,60.288c-.444.444-.3,1.036-.3,1.554V70.65c0,.518.148,1.332-.592,1.332-.814.074-.814-.74-.814-1.332V57.032c0-.518-.074-1.184.518-1.332.666-.222,1.036.3,1.332.888,1.184,2.664,2.442,5.329,3.626,8.067.222.592.518,1.11.74,1.7.148.3.148.74.592.592.37-.148.3-.592.3-.888V57.4a4.885,4.885,0,0,1,.074-1.036.756.756,0,0,1,.814-.74c.444.074.592.444.592.888V70.206c0,.592.222,1.406-.518,1.628-.814.3-1.11-.518-1.406-1.184-1.406-3.034-2.738-6.143-4.144-9.177C91.557,61.029,91.483,60.51,90.965,60.288Z",
    transform: "translate(19.086 -55.326)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34-7",
    d: "M40.851,63.85c-.074,1.628.074,3.182-.148,4.811-.37,2.294-1.628,3.4-3.922,3.4-2.442,0-3.848-1.036-4.144-3.33a41.634,41.634,0,0,1,0-10.065c.3-2.146,1.776-3.182,4-3.182a3.655,3.655,0,0,1,4,3.182,30.683,30.683,0,0,1,.222,5.181Zm-1.48,0c0-1.258.074-2.516,0-3.774-.074-1.924-1.11-3.034-2.812-2.96-1.628,0-2.59,1.036-2.664,2.96-.074,2.516-.074,5.107,0,7.623.074,1.924,1.036,2.96,2.664,3.034,1.7,0,2.738-1.036,2.812-3.034C39.445,66.44,39.371,65.182,39.371,63.85Z",
    transform: "translate(-14.8 -55.409)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36-4",
    d: "M87.182,71.058c0,.518-.074.888-.518.962a.615.615,0,0,1-.814-.444c-.074-.3-.222-.666-.3-.962-.666-2.294-.666-2.294-2.664-2.294h-.666c-2.516,0-2.516,0-3.4,2.664-.148.518-.222,1.258-.962,1.036-.74-.3-.518-1.036-.37-1.628,1.184-4.441,2.368-8.955,3.626-13.4.222-.666.3-1.628,1.258-1.554.814.074.962.888,1.11,1.554,1.11,4.219,2.294,8.437,3.4,12.73a8.6,8.6,0,0,1,.3,1.332Zm-4.959-4.144h.74c1.628,0,1.7-.074,1.184-1.924-.444-1.776-.888-3.552-1.406-5.255-.074-.37,0-.888-.444-.888s-.518.518-.592.962c-.37,1.48-.74,2.96-1.184,4.441C79.781,66.913,79.855,66.913,82.224,66.913Z",
    transform: "translate(11.99 -55.438)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38-1",
    d: "M21.341,63.85V56.967c0-1.11.37-1.48,1.258-1.48h2.516c3.4.074,4.663,1.628,4.589,5.551C29.63,63.7,28.3,65.256,26,65.4a16.691,16.691,0,0,1-1.924,0c-1.036-.074-1.406.444-1.332,1.554.074,1.332,0,2.664,0,3.922,0,.518-.074,1.11-.74,1.11s-.666-.592-.666-1.184V63.85Zm3.478.222c2.146,0,2.96-.518,3.33-2.072s.37-3.034-.74-4.218c-1.184-1.184-2.738-.666-4.144-.592-.518,0-.518.666-.518,1.184V61.7C22.747,64.072,22.747,64.072,24.819,64.072Z",
    transform: "translate(-21.341 -55.409)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40-0",
    d: "M47.5,72.241a4.4,4.4,0,0,1-3.774-1.48c-.3-.37-.666-.888-.222-1.406.37-.444.814-.148,1.11.222a3.5,3.5,0,0,0,3.034,1.184,2.489,2.489,0,0,0,2.368-1.85,3.187,3.187,0,0,0-.666-3.33A8.953,8.953,0,0,0,46.461,63.8a4.033,4.033,0,0,1-2.738-3.626c-.222-2.664.962-4.144,3.552-4.663a5.526,5.526,0,0,1,3.108.444.957.957,0,0,1,.74,1.258c-.222.74-.74.444-1.184.222a4.611,4.611,0,0,0-2.96-.37,1.96,1.96,0,0,0-1.7,1.7,2.709,2.709,0,0,0,.74,2.59,13.891,13.891,0,0,0,3.108,1.628,4.421,4.421,0,0,1,2.516,4.292c0,1.924-.444,3.4-2.072,4.367a5.245,5.245,0,0,1-2.072.592Z",
    transform: "translate(-8.273 -55.437)",
    fill: "#ff6c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42-6",
    d: "M57.471,64.442c0-1.924-.074-3.774,0-5.7.074-1.406-.444-1.85-1.554-1.7a8.92,8.92,0,0,1-1.406,0c-.444,0-.74-.222-.74-.814a.683.683,0,0,1,.666-.74h7.549a.621.621,0,0,1,.666.666.722.722,0,0,1-.74.814,11.953,11.953,0,0,1-1.628,0c-1.036-.074-1.332.444-1.332,1.554V70.658c0,.592-.074,1.258-.74,1.258-.74,0-.74-.666-.74-1.258V64.442Z",
    transform: "translate(-2.038 -55.409)",
    fill: "#ff6c37"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostman);
export default __webpack_public_path__ + "static/media/postman.c8e481fd6f2bbe524576a047289440c4.svg";
export { ForwardRef as ReactComponent };